/** Ключ navigation state: карточку парковки открыли из списка сессий — закрытие возвращает туда. */
export const PARKING_DETAILS_FROM_SESSIONS_STATE = 'parkingDetailsFromSessions';
